export enum Button {
  default = 'default',
  active= 'active',
  playing = 'playing',
  played = 'played',
  spelled = 'spelled',
}
